/** How an exchange is named on screen ("binance" → Binance). An exchange the app does not know keeps its own name. */
export function exchangeLabel(exchange: string): string {
  return exchange === 'okx' ? 'OKX' : exchange === 'binance' ? 'Binance' : exchange;
}
